import React, { useState, useEffect, useCallback } from "react";
import { useNotify } from "../../../context/NotificationContext";
import { Card, Form, Input, Button, Space, Spin } from "antd";
import { SaveOutlined } from "@ant-design/icons";

import masterService from "../../../services/masterService";
import CustomUploaderField from "../../../components/uploader/CustomUploaderField";
import { useNavigate } from "react-router-dom";

const GlobalSettingsList = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [id, setId] = useState(null);

  const fetchGlobalSettings = useCallback(async () => {
    setLoadingData(true);
    try {
      const response = await masterService.getAllGlobalSettings();
      console.log("response1111", response);
      if (response.data && response.data.status) {
        const settings = response.data.data || {};

        console.log("settings1111", settings);

        // Update color values state
        // setColorValues(newColorValues);

        form.setFieldsValue(settings);
        setId(settings.gls_id);
      } else {
        notify.error({ message: "Failed to fetch global settings" });
      }
    } catch (error) {
      console.error("Error fetching global settings:", error);
      notify.error({ message: "Error fetching global settings" });
    } finally {
      setLoadingData(false);
    }
  }, [form]);

  useEffect(() => {
    fetchGlobalSettings();
  }, [fetchGlobalSettings]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
      };

      const response = await masterService.updateAllGlobalSettings(payload, id);

      if (response.data && response.data.status) {
        notify.success({
          message:
            response.data.message || "Global settings updated successfully",
        });
        navigate("/global-settings");
      } else {
        notify.error({
          message: response.data.message || "Failed to update global settings",
        });
        navigate("/global-settings");
      }
    } catch (error) {
      console.error("Error updating global settings:", error);
      notify.error({ message: "Error updating global settings" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loadingData}>
      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          {/* {JSON.stringify(form.getFieldValue("originals_intro_url"))} */}
          <div
            style={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "24px",
            }}
          >
            <div>
              <Form.Item
                label="Originals Intro URL"
                name="originals_intro_url"
                style={{ width: "100%" }}
              >
                <CustomUploaderField
                  type="intro"
                  onUploadComplete={(data) => {
                    form.setFieldValue("originals_intro_url", data.file_name);
                    form.setFieldValue("org_bunny_guid", data.bunny_guid);
                    form.setFieldValue("org_video_id", data.video_id);
                  }}
                  onRemove={() => {
                    form.setFieldValue("originals_intro_url", null);
                  }}
                  existingName={form.getFieldValue("originals_intro_url")}
                />
              </Form.Item>
            </div>

            <div>
              <Form.Item label="Exclusive Intro URL" name="exclusive_intro_url">
                <CustomUploaderField
                  type="intro"
                  onUploadComplete={(data) => {
                    form.setFieldValue("exclusive_intro_url", data.file_name);
                    form.setFieldValue("exc_bunny_guid", data.bunny_guid);
                    form.setFieldValue("exc_video_id", data.video_id);
                  }}
                  onRemove={() => {
                    form.setFieldValue("exclusive_intro_url", null);
                  }}
                  existingName={form.getFieldValue("exclusive_intro_url")}
                />
              </Form.Item>
            </div>

            <div>
              <Form.Item label="Default Intro URL" name="default_intro_url">
                <CustomUploaderField
                  type="intro"
                  onUploadComplete={(data) => {
                    form.setFieldValue("default_intro_url", data.file_name);
                    form.setFieldValue("default_bunny_guid", data.bunny_guid);
                    form.setFieldValue("default_video_id", data.video_id);
                  }}
                  onRemove={() => {
                    form.setFieldValue("default_intro_url", null);
                  }}
                  existingName={form.getFieldValue("default_intro_url")}
                />
              </Form.Item>
            </div>
          </div>

          {/* Hidden Fields */}
          <Form.Item name="org_bunny_guid" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="org_video_id" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="exc_bunny_guid" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="exc_video_id" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="default_bunny_guid" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="default_video_id" hidden>
            <Input type="hidden" />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 16, offset: 8 }}>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                loading={loading}
              >
                Update
              </Button>
              {/* <Button onClick={handleReset} icon={<ReloadOutlined />}>
                Reset
              </Button> */}
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
};

export default GlobalSettingsList;
